import React, { useEffect, useState } from 'react'
import ModalCirugia from '../../ModalCirugia'
import ModalConsentimientoInformado from '../../../pages/ModalConsentimientoInformado'
import CambioDeEstadoIngresoASala from '../cambioDeEstado/CambioDeEstadoIngresoASala'
import CambioDeEstadoPreparado from '../cambioDeEstado/CambioDeEstadoPreparado'
import CambioDeEstadoRecuperacion from '../cambioDeEstado/CambioDeEstadoRecuperacion'
import CambioDeEstadoSalida from '../cambioDeEstado/CambioDeEstadoSalida'
import CambioDeEstadoRealizada from '../cambioDeEstado/CambioDeEstadoRealizada'
import CambioDeEstadoCirugia from '../cambioDeEstado/CambioDeEstadoCirugia'
import { calcularEdad } from '../../../hooks/UseDate'
import ModalAgregarPaquetesQuirurgicos from '../modalProcedimiento/ModalAgregarPaquetesQuirurgicos'
import ModalValidarButtonModificarProgramacionCirugia from '../../ModalValidarButtonModificarProgramacionCirugia'
import ModalValidarCirugia from './ModalValidarCirugia'
import NovedadesAdministrativas from '../novedadesAdministrativas/NovedadesAdministrativas'
import ModalConfirmarPDFListaChequeo from './ModalConfirmarPDFListaChequeo'
import ModalConsentimientoInformacionCirugiaPrincipal from '../modalCirugia/ModalConsentimientoInformacionCirugiaPrincipal'
import CambioDeEstadoIngresoASalaCirugiaPequena from '../cambioDeEstado/CambioDeEstadoIngresoASalaCirugiaPequena'

const TablaGestionCX = (props) => {
    const [modalOn, setModalOn] = useState(false);
    const [choice, setChoice] = useState(false)
    const [modalOnAgregarPaquetesQuirurgicos,setmodalOnAgregarPaquetesQuirurgicos]=useState(false)
    const [modalOnValidarCirugia, setmodalOnValidarCirugia]=useState(false)
    const [modalOnConsentimientoInformado, setmodalOnConsentimientoInformado]=useState(false)
    const [modalOnCambioEstadoIngresoSala, setmodalOnCambioEstadoIngresoSala]=useState(false)
    const [modalOnCambioEstadoPreparado, setmodalOnCambioEstadoPreparado]=useState(false)
    const [modalOnCambioEstadoRecuperacion, setmodalOnCambioEstadoRecuperacion]=useState(false)
    const [modalOnCambioEstadoSalida, setmodalOnCambioEstadoSalida]=useState(false)
    const [modalOnCambioEstadoRealizada, setmodalOnCambioEstadoRealizada]=useState(false)
    const [modalOnModificarButton, setmodalOnModificarButton]=useState(false)
    const [modalOnCambioEstadoCirugia,setmodalOnCambioEstadoCirugia]=useState(false)
    const [actualizarTable, setactualizarTable]=useState([])
    const [modalOnCambioEstadoIngresoAsalaPequenaCirugiaa, setmodalOnCambioEstadoIngresoAsalaPequenaCirugiaa]=useState(false)
    const [novedadesAdministra, setnovedadesAdministra]=useState(false)
    const [modalOnListaChequeo, setmodalOnListaChequeo]=useState(false)
    const [diseableCambioEstado, setdiseableCambioEstado]=useState({
        estadoPaciente:'6',
        disabledPendiente:false,
        disabledReservado:false,
        disabledConfirmado:false,
        disabledIngresoSala:false,
        disabledPreparado:false,
        disabledCirugia:false,
        disabledRecuperacion:false,
        disabledSalida:false,
        disabledCancelar:false,
        disabledRealizada:false,
        disabledFacturada:false
      })
    useEffect(()=>{
      console.log(props.user,'EStados')
      
    if(props.user.ultimoEstado ==='recuperacion'){
            setdiseableCambioEstado({
              estadoPaciente:'15',
              disabledPendiente:true,
              disabledReservado:true,
              disabledConfirmado:true,
              disabledIngresoSala:true,
              disabledPreparado:true,
              disabledCirugia:true,
              disabledRecuperacion:true,
              disabledSalida:false,
              disabledCancelar:true,
              disabledRealizada:true,
              disabledFacturada:true
            })
            
    }
    else if(props.user.ultimoEstado ==='salida'){
      setdiseableCambioEstado({
        estadoPaciente:'14',
        disabledPendiente:true,
        disabledReservado:true,
        disabledConfirmado:true,
        disabledIngresoSala:true,
        disabledPreparado:true,
        disabledCirugia:true,
        disabledRecuperacion:true,
        disabledSalida:true,
        disabledCancelar:true,
        disabledRealizada:true,
        disabledFacturada:true
      })
      
}
    else      if(props.user.ProEsta === '4'){
      setdiseableCambioEstado({
        estadoPaciente:'4',
        disabledPendiente:true,
        disabledReservado:true,
        disabledConfirmado:true,
        disabledIngresoSala:true,
        disabledPreparado:true,
        disabledCirugia:true,
        disabledRecuperacion:false,
        disabledSalida:true,
        disabledCancelar:true,
        disabledRealizada:true,
        disabledFacturada:true
      })
        
    }
    else if(props.user.ultimoEstado ==='confirmado'){
      setdiseableCambioEstado({
        estadoPaciente:'2',
        disabledPendiente:true,
        disabledReservado:true,
        disabledConfirmado:true,
        disabledIngresoSala:false,
        disabledPreparado:true,
        disabledCirugia:true,
        disabledRecuperacion:true,
        disabledSalida:true,
        disabledCancelar:false,
        disabledRealizada:true,
        disabledFacturada:true
      })
        
}else if(props.user.ultimoEstado ==='ingreso a sala'){
          setdiseableCambioEstado({
            estadoPaciente:'11',
            disabledPendiente:true,
            disabledReservado:true,
            disabledConfirmado:true,
            disabledIngresoSala:true,
            disabledPreparado:false,
            disabledCirugia:true,
            disabledRecuperacion:true,
            disabledSalida:true,
            disabledCancelar:true,
            disabledRealizada:true,
            disabledFacturada:true
          })
         
  }else if(props.user.ultimoEstado ==='preparado'){
          setdiseableCambioEstado({
            estadoPaciente:'12',
            disabledPendiente:true,
            disabledReservado:true,
            disabledConfirmado:true,
            disabledIngresoSala:true,
            disabledPreparado:true,
            disabledCirugia:false,
            disabledRecuperacion:true,
            disabledSalida:true,
            disabledCancelar:true,
            disabledRealizada:true,
            disabledFacturada:true
          })
          
  }else if(props.user.ultimoEstado ==='cirugia'){
    setdiseableCambioEstado({
      estadoPaciente:'13',
      disabledPendiente:true,
      disabledReservado:true,
      disabledConfirmado:true,
      disabledIngresoSala:true,
      disabledPreparado:true,
      disabledCirugia:true,
      disabledRecuperacion:true,
      disabledSalida:true,
      disabledCancelar:true,
      disabledRealizada:false,
      disabledFacturada:true
    })
    
}
    else if(parseInt(props.user.ProEsta) === 2){
      setdiseableCambioEstado({
        estadoPaciente:'2',
        disabledPendiente:true,
        disabledReservado:true,
        disabledConfirmado:true,
        disabledIngresoSala:false,
        disabledPreparado:true,
        disabledCirugia:true,
        disabledRecuperacion:true,
        disabledSalida:true,
        disabledCancelar:true,
        disabledRealizada:true,
        disabledFacturada:true
      })
        
    }
    },[actualizarTable,props.user.ProCirCod])
    //cambio de estado
    const handleState=(e)=>{
      e.preventDefault();
      if(e.target.value == "11"){
        if(props.user.PequenaCirugia === "S"){
          setmodalOnCambioEstadoIngresoAsalaPequenaCirugiaa(true)
        }else{
          setmodalOnCambioEstadoIngresoSala(true)
        }
        
      }
      if(e.target.value == "12"){
        setmodalOnCambioEstadoPreparado(true)
      }
      if(e.target.value == "13"){
        setmodalOnCambioEstadoCirugia(true)
        //setmodalOnValidarCirugia(true)
      }
      if(e.target.value == "14"){
        setmodalOnCambioEstadoSalida(true)
      }
      if(e.target.value == "15"){
        //setmodalOnCambioEstadoRecuperacion(true)
        //setmodalOnValidarCirugia(true)
        setmodalOnCambioEstadoRealizada(true)
      }
      if(e.target.value == "4"){
        setmodalOnValidarCirugia(true)
        //setmodalOnCambioEstadoRealizada(true)
      }
    }
    //modifcar cirugia
    const modificar = ()=>{  
      if(parseInt(props.user.ProEsta) === 4){
        setmodalOnModificarButton(true)
      }else{
        setModalOn(true)
      }
        
      }
    //Agregar paquetes qx
    const handleOnclickPaquetesQx=()=>{
      //setmodalOnPaquetesQx(true)
      // if(props.user.ProEsta == '4'){
      //   setmodalOnModificarButton(true)
      // }else{
        setmodalOnAgregarPaquetesQuirurgicos(true)
      //}
      
    }
    //consentimiento informado PDF
    const handleClickConsentimientoInformado=()=>{
      setmodalOnConsentimientoInformado(true)
    }
    const passActualizarTablaProcedimiento=(data)=>{
        setactualizarTable(data)
      }
    
      const passChildCambioDeEstado=(data)=>{
        setdiseableCambioEstado(data)
      }

      //novedades administrativas
      const handleOnClickNovedadesAdministrativas=()=>{
        setnovedadesAdministra(true)
      }

      //lista chequeo
      const handleOnclickListaChequeo=()=>{
        setmodalOnListaChequeo(true)
      }
  return (
    <>
         <tbody >
        <tr className={(props.user.cantidadProcedimientos > 1)?"divide-y divide-slate-700 bg-[#a7f3d0]":"divide-y divide-slate-700 "}>
          <td></td>
          <td className="text-xs text-gray-900 font-medium px-3  whitespace-pre-wrap">
            <div className="pt-2 w-32 ">
              <div className="mb-3 xl:w-96">
                <select onChange={handleState} value={diseableCambioEstado.estadoPaciente} className="form-select block w-30 px-2 py-1.5 text-base font-medium text-gray-700 bg-white bg-clip-padding bg-no-repeat
                  border border-solid border-gray-300 rounded transition  ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" 
                  aria-label="Default select example"> 
                    <option value="2" disabled={diseableCambioEstado.disabledConfirmado}>Confirmado</option>
                    <option value="11" disabled={diseableCambioEstado.disabledIngresoSala}>Ingreso a sala</option>
                    <option value="12" disabled={diseableCambioEstado.disabledPreparado}>Preparación</option>
                    <option value="13" disabled={diseableCambioEstado.disabledCirugia}>Cirugía</option>
                    <option value="4" disabled={diseableCambioEstado.disabledRealizada}>Realizada</option>
                    <option value="15" disabled={diseableCambioEstado.disabledRecuperacion}>Recuperación</option>                    
                    <option value="14" disabled={diseableCambioEstado.disabledSalida}>Salida</option>
                    
                    {/* <option value="5" disabled={diseableCambioEstado.disabledFacturada}>Facturada</option> */}
                    {/* <option value="3" disabled={diseableCambioEstado.disabledCancelar}>Cancelada</option> */}
                </select>
              </div>
            </div>
          </td>
          <td className="text-xs text-gray-900 font-medium px-1 py-2 whitespace-pre-wrap">
          <button
  onClick={handleOnClickNovedadesAdministrativas}
  type="button"
  className="relative inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out group"
>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth="1.5" 
    stroke="currentColor" 
    className="w-4 h-4"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 5C7 5 2.73 8.82 1.5 12.5c1.23 3.68 5.5 7.5 10.5 7.5s9.27-3.82 10.5-7.5C21.27 8.82 17 5 12 5z"></path>
    <circle cx="12" cy="12.5" r="3" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"></circle>
  </svg>

  {/* Tooltip personalizado */}
  <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 opacity-0 group-hover:opacity-100 bg-gray-700 text-white text-xs rounded px-2 py-1 transition-opacity duration-150">
    Novedades Administrativas
  </span>
</button>
          </td>
          {
            props.user.listaChequeo === 'Si'?
            <td className="text-xs text-gray-900 font-medium  whitespace-pre-wrap">
              <button
                onClick={handleOnclickListaChequeo}
                type="button"
                className="relative inline-block px-1 py-0.5 bg-blue-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out group"
              >
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  fill="none" 
                  viewBox="0 0 24 24" 
                  strokeWidth="1.5" 
                  stroke="currentColor" 
                  className="w-6 h-6"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
                </svg>

                {/* Tooltip personalizado */}
                <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 opacity-0 group-hover:opacity-100 bg-gray-700 text-white text-xs rounded px-2 py-1 transition-opacity duration-150">
                  Lista de Chequeo
                </span>
              </button>
            </td>
          :
          <td className="text-xs text-gray-900 font-medium  whitespace-pre-wrap"></td>
          }
          
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            <div className="">
              {parseInt(props.user.ProEsta) !== 3?
              <button
              onClick={modificar}
              //disabled={false}
              type="button"
              className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
            >
              Modificar
            </button>:
            null  
            }
                    
            </div>
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            {parseInt(props.user.ProEsta) !== 3?
            <button
            onClick={handleOnclickPaquetesQx}
            type="button"
            className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          >
            Paquetes
          </button>:
          null
          }
                    
            
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
          <button
                      onClick={handleClickConsentimientoInformado}
                      type="button"
                      className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                    >
                      Consentimiento
                    </button>
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.ProCirCod? props.user.ProCirCod:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.MPTDoc? props.user.MPTDoc:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.MPCedu? props.user.MPCedu:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 text-left whitespace-pre-wrap">
          <div className='flex '>
            {props.user.MPNOMC? props.user.MPNOMC:null }

            {
              props.user.PrcMulDsc? (props.user.PrcMulDsc.trim() === "PROGRAMADA"? 
              <div className="ml-2 h-6 w-6 rounded-full bg-blue-300 flex justify-center items-center text-blue-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">P</text>
  </svg>
</div>
:
(props.user.PrcMulDsc.trim() === "URGENCIAS"? 
<div className="ml-2 h-6 w-6 rounded-full bg-red-300 flex justify-center items-center text-red-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">U</text>
  </svg>
</div> 
:
(props.user.PrcMulDsc.trim() === "AMBULATORIA"? 
<div className="ml-2 h-6 w-6 rounded-full bg-blue-400 flex justify-center items-center text-blue-800">
  <svg viewBox="0 0 24 24" className="h-6 w-6">
    <text x="50%" y="50%" fill="currentColor" font-size="20" text-anchor="middle" alignment-baseline="central">A</text>
  </svg>
</div> 
:
null
)
)

              ) :null
            }
            
            
 
</div>
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {props.user.ProFec? props.user.ProFec.split(' ')[0]:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.CrgDes? props.user.CrgDes:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.ProHorI != "  :  :  "? props.user.ProHorI:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.ProHorF? props.user.ProHorF:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.MPTele?props.user.MPTele:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.ConsDet? props.user.ConsDet:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            {props.user.MPFchN? calcularEdad(props.user.MPFchN.split(' ')[0]):null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left ">
            {props.user.MENOMB? props.user.MENOMB:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left ">
            {props.user.camaUsuario? props.user.camaUsuario:null}
          </td>
        </tr>     
        </tbody>
      {modalOn && < ModalCirugia setModalOn={setModalOn} setChoice={setChoice} user={props.user} passDataActualizaTablaPacientes={props.passDataActualizaTablaPacientes}/>} 
      {/* {modalOnPaquetesQx? <ModalAgregarPaquetesQuirurgicosP setmodalOnPaquetesQx={setmodalOnPaquetesQx} user={props.user}/>:null} */}
      {modalOnAgregarPaquetesQuirurgicos? <ModalAgregarPaquetesQuirurgicos setmodalOnAgregarPaquetesQuirurgicos={setmodalOnAgregarPaquetesQuirurgicos} idCirugia={props.user.ProCirCod} user={props.user} passActualizarTablaProcedimiento={passActualizarTablaProcedimiento}/>:null}
      
      {/* {modalOnConsentimientoInformado? <ModalConsentimientoInformado setmodalOnConsentimientoInformado={setmodalOnConsentimientoInformado} user={props.user}/>:null} */}
      {modalOnConsentimientoInformado? <ModalConsentimientoInformacionCirugiaPrincipal setmodalOnConsentimientoInformado={setmodalOnConsentimientoInformado} user={props.user}/>:null}
        
      {modalOnCambioEstadoIngresoSala? <CambioDeEstadoIngresoASala setmodalOnCambioEstadoIngresoSala={setmodalOnCambioEstadoIngresoSala} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado} passDataActualizaTablaPacientes={props.passDataActualizaTablaPacientes}/>:null}
      {modalOnCambioEstadoPreparado? <CambioDeEstadoPreparado setmodalOnCambioEstadoPreparado={setmodalOnCambioEstadoPreparado} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnCambioEstadoCirugia? <CambioDeEstadoCirugia setmodalOnCambioEstadoCirugia={setmodalOnCambioEstadoCirugia} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnCambioEstadoRecuperacion? <CambioDeEstadoRecuperacion setmodalOnCambioEstadoRecuperacion={setmodalOnCambioEstadoRecuperacion} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnCambioEstadoSalida? <CambioDeEstadoSalida setmodalOnCambioEstadoSalida={setmodalOnCambioEstadoSalida} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {modalOnCambioEstadoRealizada? <CambioDeEstadoRealizada setmodalOnCambioEstadoRealizada={setmodalOnCambioEstadoRealizada} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>:null}
      {/* {modalOnValidarDiagnostico? <ModalValidarDiagnosticoAntesDeConfirmarCirugia setmodalOnValidarDiagnostico={setmodalOnValidarDiagnostico}/>:null} */}
      {modalOnModificarButton? <ModalValidarButtonModificarProgramacionCirugia setmodalOnModificarButton={setmodalOnModificarButton}/>:null}
      {modalOnCambioEstadoIngresoAsalaPequenaCirugiaa && <CambioDeEstadoIngresoASalaCirugiaPequena setmodalOnCambioEstadoIngresoAsalaPequenaCirugiaa={setmodalOnCambioEstadoIngresoAsalaPequenaCirugiaa} user={props.user} passChildCambioDeEstado={passChildCambioDeEstado}/>}
      {modalOnValidarCirugia? <ModalValidarCirugia setmodalOnValidarCirugia={setmodalOnValidarCirugia}/>:null}
      {novedadesAdministra? <NovedadesAdministrativas setnovedadesAdministra={setnovedadesAdministra} user={props.user}/>:null}
      {modalOnListaChequeo? <ModalConfirmarPDFListaChequeo setmodalOnListaChequeo={setmodalOnListaChequeo} user={props.user}/>:null}
      </>
  )
}

export default TablaGestionCX